"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  default: 'default',
  disabled: 'disabled',
  shoppingListApi: 'ShoppingListApi',
  iows: 'IOWS',
  chinaShoppingListApi: 'ChinaShoppingListApi',
  mvecom: 'MvEcom'
};
exports.default = _default;